import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'usehooks-ts'

import { useCartInfoStore, useCartStore, useMutateClearCart } from '@entities/Cart'

import { useAuth } from '@features/auth'
import useClearCartModal from '@features/cart/hooks/useClearCart'
import { useErrorInfoModal } from '@features/modal'
import { useAddressStore } from '@features/shipping-methods'

import { useAnalytics } from '@shared/lib/analytics'
import Button from '@shared/ui/button'

import styles from './styles.module.scss'



export default function ClearCartModal () {
  const { t: tc } = useTranslation('common')
  const { clearCart } = useCartStore()
  const cartInfo = useCartInfoStore((state) => state.cartInfo)
  const { openErrorInfoModal } = useErrorInfoModal()
  const { closeClearCartModal } = useClearCartModal()
  const { isAuthorized } = useAuth()
  const [ fetchClearCart ] = useMutateClearCart()
  const { shopId } = useAddressStore()
  const { removeFromCart: trackRemoveFromCart } = useAnalytics()

  const isTablet = useMediaQuery('(max-width: 768px)')
  const buttonSize = isTablet ? 'medium' : 'large'

  const handleClearCart = async () => {
    // Track analytics: removing all products from cart
    if (cartInfo?.products) {
      cartInfo.products.forEach((item) => {
        if (item?.info) {
          trackRemoveFromCart(item.info, item.amount)
        }
      })
    }

    if (isAuthorized) {
      try {
        await fetchClearCart({
          variables: {
            shopId,
          },
        })

        clearCart()
      }
      catch (error) {
        console.error('fetchClearCart error: ', error)
        openErrorInfoModal({
          description: tc('clear_cart'),
        })
      }
    }
    else {
      clearCart()
    }

    closeClearCartModal()
  }

  return (
    <div className={styles.modal}>
      <Button onClick={handleClearCart} size={buttonSize}>
        {tc('yes')}
      </Button>
      <Button onClick={closeClearCartModal} theme="grey" size={buttonSize}>
        {tc('no')}
      </Button>
    </div>
  )
}
